import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ContextMenuIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import BulletinIconOutlined from '@material-ui/icons/TurnedInNot';
import BulletinIcon from '@material-ui/icons/TurnedIn';
import theme from '../../app.theme';
import { ThemeColors } from '../../theme';
// import ENV from '../../../run-config';
// import pdfIcon from '../../../images/pdf_small.png';

class Tile extends Component {

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      isPinned: this.props.isPinned,
    };

    this.contextMenuItems = this.setContextMenuIcons();
  }

  get isPinned() {
    return this.state.isPinned != null ? this.state.isPinned : this.props.isPinned;
  }


  setContextMenuIcons() {
    const menuItems = [];
    const bulletinText = this.isPinned
      ? 'Von meinen Inhalten entfernen'
      : 'Zu meinen Inhalten hinzufügen';


    if (!this.props.config) return [];

    if (this.props.config && this.props.config.sharingEnabled === 'true') {
      menuItems.push(
        <MenuItem onClick={this.props.onClickShare}>Als PDF herunterladen</MenuItem>,
        );
    }

    if (this.props.config &&
      this.props.config.bulletinBoardActive === 'true' &&
      this.props.course.type !== 'test') {
      menuItems.push(
        <MenuItem onClick={this.handlePinContent}>{bulletinText}</MenuItem>,
      );
    }

    // if (this.props.config && this.props.config.allowRestartCourse === 'true') {
    //   menuItems.push(
    //     <MenuItem onClick={() => this.props.onRestart()}>Kurs neu starten</MenuItem>,
    //     );
    // }

    return menuItems;
  }

  handleOpenContextMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  handlePinContent = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const pinContentDto = {
      contentType: 'course',
      contentId: this.props.course.id,
    };

    this.setState({
      isPinned: !this.state.isPinned,
    });

    this.props.pinOrUnpinContent(this.props.bulletinBoard.id, pinContentDto);
  }

  renderSubtitle() {
    if (!this.props.subtitle) {
      return null;
    }
    const { classes } = this.props;

    return <p className={`pm-card-subtitle-v2 ${classes.subtitleStyle}`} >{this.props.subtitle}</p>;
  }

  renderBulletinIcon = () => {
    if (!this.props.config || this.props.config.bulletinBoardActive != 'true') return null;
    if (this.props.course.type === 'test') return null;
    if (this.props.isResultTile) return null;

    if (!this.isPinned) {
      return <BulletinIconOutlined style={{ color: ThemeColors.accent1Color, cursor: 'pointer' }} onClick={this.handlePinContent} />
    };
    return <BulletinIcon style={{ color: ThemeColors.accent1Color, cursor: 'pointer' }} onClick={this.handlePinContent} />;
  }

  renderProgressBar() {
    const backgroundColor = ThemeColors.noProgressBgColor;
    const { classes } = this.props;
    const fillColor = this.props.progress >= 1
    ? ThemeColors.fullProgressbarColor
    : ThemeColors.progressBgColor;

    return (
      <div className={classes.progressBarOuterContainer} style={{ backgroundColor }}>
        <div className={classes.progressBarInnerContainer} style={{ width: `${this.props.progress * 100}%`, backgroundColor: fillColor }} />
      </div>
    );
  }

//   renderExportIcon() {
//     if (!ENV.exportFeature || (
//       this.props.config.sharingEnabled && this.props.config.sharingEnabled === 'false')) {
//       return null;
//     }
//     return (
//       <img src={pdfIcon} style={styles.pdfIcon} onClick={this.props.onClickShare} />
//     );
//   }

  renderContextMenuIcon() {
    const { classes } = this.props;
    // if (!this.props.allowPinningContent) return null;
    if (!this.contextMenuItems || this.contextMenuItems.length < 1) return null;

    return (
      <div className={classes.iconContainerStyle}>
        <ContextMenuIcon className={classes.iconsStyle} onClick={this.handleOpenContextMenu} />
      </div>
    );
  }

  renderContextMenu() {
    return (
      <Menu
        id="context-menu"
        anchorEl={this.state.anchorEl}
        keepMounted
        open={this.state.anchorEl}
        onClose={() => this.setState({ anchorEl: null })}
      >
        {this.contextMenuItems}
      </Menu>
    );
  }

  renderCardCount = () => {
    if (!this.props.course) return null;
    const { masteredCardsCount, cardsCount } = this.props.course;
    if ((!masteredCardsCount && masteredCardsCount !== 0) || !cardsCount) return null;

    return <Typography>{`${masteredCardsCount} von ${cardsCount}`}</Typography>;
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={this.props.className || 'col-xs-6 col-sm-6 col-lg-3 col-md-4'} >
        <div className={classes.outerContainerStyle} onClick={this.props.onClick}>
          <div
            className={`pm-card-v2 ${classes.contextMenuContainer}`}
            style={{
              backgroundImage: `url(${this.props.imageUrl})`,
            }}
          >
            {/* {this.renderExportIcon()} */}
            {this.renderContextMenuIcon()}
          </div>
          {this.renderProgressBar()}
          <div className={classes.contentContainer} >
            <span className={`${classes.title} pm-card-title-v2 `} style={{ bottom: this.props.subtitle ? '25px' : '5px' }}>{this.props.title && this.props.title.toUpperCase()}</span>
            {this.renderSubtitle()}

            <div className={classes.innerContainerStyle}>
              {this.renderCardCount()}
              {this.renderBulletinIcon()}
            </div>

          </div>
        </div>
        {this.renderContextMenu()}
      </div>
    );
  }
}

Tile.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  subtitle: PropTypes.string,
  isPinned: PropTypes.bool,
  allowPinningContent: PropTypes.bool,
  progress: PropTypes.number,
  classes: PropTypes.object.isRequired,
  config: PropTypes.object,
  course: PropTypes.object,
  onClickShare: PropTypes.func,
  onClick: PropTypes.func,
};

Tile.defaultProps = {
  title: '',
  subtitle: '',
  imageUrl: '',
  className: '',
  isPinned: false,
  allowPinningContent: false,
  progress: 0,
  config: null,
  course: {},
  onClickShare: () => {},
  onClick: () => {},
};

const style = () => ({
  iconsStyle: {
    zIndex: 1000,
    height: 25,
    width: 25,
    margin: 2,
    color: 'black',
    backgroundColor: 'white', // 'rgba(255, 255, 255, 0.75)',
    borderRadius: '100%',
  },
  iconContainerStyle: {
    position: 'absolute',
    top: 2,
    right: 2,
    zIndex: 100,
  },
  contentContainer: {
    backgroundColor: '#fff',
    height: 95,
    padding: 10,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  innerContainerStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  outerContainerStyle: {
    position: 'relative',
    margin: 10,
    marginLeft: 0,
    minHeight: 270,
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
    borderRightColor: '#ddd',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    boxShadow: '-1px -4px 72px 8px rgba(115,115,115,0.07)',
    zIndex: 4,
  },
  title: {
    // marginTop: '10px',
    paddingRight: '15px',
    marginBottom: 0,
    bottom: '5px',
    width: '100%',
    hyphens: 'auto',
    WebkitHyphens: 'auto',
    wordWrap: 'break-word',
  },
  contextMenuContainer: {
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    cursor: 'pointer',
    zIndex: 4,
  },
  progressBarOuterContainer: {
    position: 'relative',
    height: 10,
    width: '100%',
  },
  progressBarInnerContainer: {
    position: 'relative',
    height: 10,
    bottom: 0,
    width: '5px',
  },
  subtitleStyle: {
    backgroundColor: 'rgba(255,255,255,0.6)',
    paddingRight: '15px',
    marginBottom: 0,
    bottom: 5,
    position: 'absolute',
    lineHeight: '20px',
    minHeight: '30px',
    width: '100%',
    hyphens: 'auto',
    WebkitHyphens: 'auto',
  },
});

export default withStyles(style)(Tile);



// WEBPACK FOOTER //
// ./src/app/components/tile/tilev3.js